import React from 'react';

const Sheet = ({ children, open, onOpenChange }) => {
  return (
    <div>
      {React.Children.map(children, child =>
        React.cloneElement(child, { open, onOpenChange })
      )}
    </div>
  );
};

const SheetTrigger = React.forwardRef(({ className = '', children, open, onOpenChange, asChild, ...props }, ref) => {
  const handleClick = () => onOpenChange(!open);
  
  if (asChild) {
    return React.cloneElement(children, {
      ref,
      onClick: handleClick,
      ...props
    });
  }
  
  return (
    <button
      ref={ref}
      className={className}
      onClick={handleClick}
      {...props}
    >
      {children}
    </button>
  );
});
SheetTrigger.displayName = 'SheetTrigger';

const SheetContent = React.forwardRef(({ className = '', children, open, onOpenChange, side = 'right', ...props }, ref) => {
  if (!open) return null;
  
  const sideClasses = {
    top: 'inset-x-0 top-0 border-b',
    bottom: 'inset-x-0 bottom-0 border-t',
    left: 'inset-y-0 left-0 h-full w-3/4 border-r sm:max-w-sm',
    right: 'inset-y-0 right-0 h-full w-3/4 border-l sm:max-w-sm'
  };
  
  return (
    <>
      <div className="fixed inset-0 z-50 bg-background/80 backdrop-blur-sm" onClick={() => onOpenChange(false)} />
      <div
        ref={ref}
        className={`fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out ${sideClasses[side]} ${className}`}
        {...props}
      >
        {children}
      </div>
    </>
  );
});
SheetContent.displayName = 'SheetContent';

export {
  Sheet,
  SheetTrigger,
  SheetContent,
};